import { Validator } from 'vee-validate';

const validateDocument = {
  calcDigit(digits, table) {
    const sum = digits.reduce((sum, cur, i) => (i < table.length ? sum + cur * table[i] : sum), 0);
    const rem = sum % 11;

    return rem < 2 ? 0 : 11 - rem;
  },

  CPF(val) {
    const digit = new Array(2);
    const table = [10, 9, 8, 7, 6, 5, 4, 3, 2];

    val = val.replace(/\D/g, '');

    const numbers = val.split(/(?!$)/u).map((char) => parseInt(char));

    if (val.length !== 11) return false;

    // Validação dos CPFs inválidos conhecidos
    if (/^(.)\1+$/.test(val)) return false;

    // Validação do primeiro digito
    digit[0] = validateDocument.calcDigit(numbers, table);

    // Validação segundo digito
    table.unshift(11);
    digit[1] = validateDocument.calcDigit(numbers, table);

    return digit[0] === numbers[9] && digit[1] === numbers[10];
  },

  CNPJ(val) {
    const digit = new Array(2);
    const table = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    val = (val || '').toUpperCase().replace(/[^0-9A-Z]/g, '');

    const values = val
      .split(/(?!$)/u)
      .map((char) => char.charCodeAt(0) - 48);

    if (val.length !== 14) return false;

    // Validação dos CNPJs inválidos conhecidos
    if (/^(.)\1+$/.test(val)) return false;

    const checkDigit0 = parseInt(val[12], 10);
    const checkDigit1 = parseInt(val[13], 10);

    if (Number.isNaN(checkDigit0) || Number.isNaN(checkDigit1)) return false;

    // Validação do primeiro digito
    digit[0] = validateDocument.calcDigit(values, table);

    // Validação segundo digito
    table.unshift(6);
    digit[1] = validateDocument.calcDigit(values, table);

    return digit[0] === checkDigit0 && digit[1] === checkDigit1;
  },

  all(val) {
    const numericValue = (val || '').replace(/\D/g, '');

    if (numericValue.length === 11) {
      return validateDocument.CPF(numericValue);
    }

    const alphaNumericValue = (val || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
    return alphaNumericValue.length === 14 && validateDocument.CNPJ(alphaNumericValue);
  },
};

Validator.extend('cpf', {
  validate: validateDocument.CPF,
});

Validator.extend('cnpj', {
  validate: validateDocument.CNPJ,
});

Validator.extend('document', {
  validate: validateDocument.all,
});

Validator.extend('credit_card', {
  validate: (val) => {
    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(val)) return false;

    val = val.replace(/\D/g, '');

    // The Luhn Algorithm. It's so pretty.
    let check = 0; let digit = 0; let
      even = false;

    for (let n = val.length - 1; n >= 0; n--) {
      digit = parseInt(val.charAt(n), 10);

      if (even) {
        if ((digit *= 2) > 9) digit -= 9;
      }

      check += digit;
      even = !even;
    }

    return (check % 10) == 0;
  },
});

Validator.extend('zip_code', {
  validate: (val) => {
    val = val.replace(/\D/g, '');
    return val.length === 8;
  },
});

export default Validator;
